export const featureFlags = {
	isAbacusEnabled: import.meta.env.VITE_IS_ABACUS_ENABLED === "true",
	isAuthEnabled: import.meta.env.VITE_ENABLE_AUTH === "true",
	isHowToEnabled: import.meta.env.VITE_IS_HOW_TO_ENABLED === "true",
	isCuriosityMockEnabled: import.meta.env.VITE_IS_CURIOSITY_MOCK_ENABLED === "true",
};
